import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AllAppointmentsData } from 'src/app/_models/all-appointments.model';
import { AllAppointmentsapi } from 'src/app/_services/allappointments.service';
import * as XLSX from 'xlsx';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { AppointmentDetailsComponent } from '../components/appointment-details/appointment-details.component';
import { AddProplemModalComponent } from '../components/add-proplem-modal/add-proplem-modal.component';
import { CloseProblemModalComponent } from '../components/close-problem-modal/close-problem-modal.component';
import { ReactiveModalComponent } from '../components/reactive-modal/reactive-modal.component';
import { RefundModalComponent } from '../components/refund-modal/refund-modal.component';
import { ApointmentSortingDirective } from 'src/app/_directives/appointments/apointment-sorting.directive';
import { ISortEvent } from './../../../_interfaces/appointments/sort-event';

@Component({
  selector: 'app-live-appointments',
  templateUrl: './live-appointments.component.html',
  styleUrls: ['./live-appointments.component.scss'],
})
export class LiveAppointmentsComponent implements OnInit {
  pageTitle: string = 'Live Appointments';
  placeholder: string = 'Search by patient name or doctor name …';
  liveAppointmentsArray: AllAppointmentsData[] = [];
  filteredLiveAppointmentsArray: AllAppointmentsData[] = [];
  statusList = [
    { id: 1, state: 'Pending' },
    { id: 2, state: 'Finished' },
    { id: 3, state: 'Cancelled' },
    { id: 4, state: 'Not Completed' },
    { id: 5, state: 'History' },
    { id: 0, state: 'All' },
    { id: 7, state: 'Ready To Join' },
    { id: 8, state: 'Active' },
  ];
  modalRef: BsModalRef;
  @ViewChildren(ApointmentSortingDirective)
  headers: QueryList<ApointmentSortingDirective>;
  selectedTab: string = 'All';

  constructor(
    private _AllAppoint: AllAppointmentsapi,
    public toastr: ToastrService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.getLiveAppointments();
  }

  getLiveAppointments() {
    this._AllAppoint.getLiveAppintments().subscribe((response) => {


      if (response?.['data']?.appointments.length > 0) {
        response?.['data']?.appointments.map((Appointment) => {
          this.liveAppointmentsArray.push(Appointment);
        });
      }

      this.filteredLiveAppointmentsArray = [...this.liveAppointmentsArray];
    });
  }

  compare = (v1: string | number, v2: string | number) =>
    v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

  onSort({ column, direction }: ISortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // sorting countries
    if (direction === '' || column === '') {
      this.filteredLiveAppointmentsArray = this.filteredLiveAppointmentsArray;
    } else {
      this.filteredLiveAppointmentsArray = [...this.filteredLiveAppointmentsArray].sort(
        (a, b) => {
          const res = this.compare(a[column], b[column]);
          return direction === 'asc' ? res : -res;
        }
      );
    }
  }

  onSearchAppointment(searchString) {
    searchString = searchString.toLocaleLowerCase();

    if (this.filteredLiveAppointmentsArray.length) {
      this.filteredLiveAppointmentsArray = this.liveAppointmentsArray.filter(
        (item) => {
          return (
            (item.patientName &&
              item.patientName.toLocaleLowerCase().includes(searchString)) ||
            (item.doctorName &&
              item.doctorName.toLocaleLowerCase().includes(searchString))
          );
        }
      );
    }
  }

  onSearchInputKeyup(searchString) {
    if (!searchString) {
      this.filteredLiveAppointmentsArray = [...this.liveAppointmentsArray];
    }
  }

  onBtnSearchAppointment(statusId) {
    this.filteredLiveAppointmentsArray = [...this.liveAppointmentsArray];

    this.selectedTab = this.statusList.find((status) => {
      return status.id == parseInt(statusId);
    }).state;

    if (statusId == '0') {
      this.filteredLiveAppointmentsArray = [...this.liveAppointmentsArray];
    } else {
      if (this.filteredLiveAppointmentsArray.length) {
        this.filteredLiveAppointmentsArray = this.liveAppointmentsArray.filter(
          (item) => {
            return item.statusId && item.statusId == statusId;
          }
        );
      }
    }
  }

  getStatusName(id) {
    return id ? this.statusList.find((status) => status.id == id)?.state : '';
  }

  capitalizeWords(text) {
    if (text && text.length) {
      return text.replace(/(?:^|\s)\S/g, (res) => {
        return res.toUpperCase();
      });
    }
  }

  ExportTOExcel(): void {
    const data = [];
    this.filteredLiveAppointmentsArray.map((appointment, index) =>
      data.push({
        patientId: appointment.patientId,
        patientName: appointment.patientName,
        profilePicturePatient: appointment.profilePicturePatient,
        doctorName: appointment.doctorName,
        profilePictureDoctor: appointment.profilePictureDoctor,
        appointmentTime: appointment.appointmentTime,
        patientStartTime: appointment.patientStartTime,
        doctorStartTime: appointment.doctorStartTime,
        creationDate: appointment.creationDate,
        appointmentEndTime: appointment.appointmentEndTime,
        endBy: appointment.endBy,
        isAnonymous: appointment.isAnonymous,
        isSe7etak: appointment.isSe7etak,
        hasProblem: appointment.hasProblem,
        isHavePrescription: appointment.isHavePrescription,
        reactive: appointment.reactive,
        refund: appointment.refund,
        comment: appointment.comment,
        doctorGet: appointment.doctorGet,
        displayName: appointment.displayName,
        callDuration: appointment.callDuration,
      })
    );
    const ws = XLSX.utils.json_to_sheet(data);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');



    /* save to file */
    XLSX.writeFile(wb, `Live Appointments.xlsx`);
  }

  onAppointmentDetails(event, item): void {
    event.stopPropagation();

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        item,
      },
    };

    this.modalRef = this.modalService.show(
      AppointmentDetailsComponent,
      initialState
    );
  }

  onRefundHandler(event, item) {
    event.stopPropagation();

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered modal-warning',
      initialState: {
        itemId: item.appointmentId,
      },
    };

    this.modalRef = this.modalService.show(RefundModalComponent, initialState);

    this.modalRef.content.event.subscribe((appointmentId) => {
      this.onRefundSubmit(appointmentId);
    });
  }

  onRefundSubmit(appointmentId) {
    this._AllAppoint.refund(appointmentId).subscribe((response) => {
      this.liveAppointmentsArray.find(
        (app) => app.appointmentId === appointmentId
      ).refund = true;
      showNotification(
        'success',
        `The appointment has been refunded`,
        this.toastr
      );
      this.modalRef.hide();
    });
  }

  onReactiveHandler(event, item) {
    event.stopPropagation();

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered modal-success',
      initialState: {
        itemId: item.appointmentId,
      },
    };

    this.modalRef = this.modalService.show(
      ReactiveModalComponent,
      initialState
    );

    this.modalRef.content.event.subscribe((appointmentId) => {
      this.onReactiveSubmit(appointmentId);
    });
  }

  onReactiveSubmit(appointmentId) {
    this._AllAppoint.reactivate(appointmentId).subscribe((response) => {
      this.liveAppointmentsArray.find(
        (app) => app.appointmentId === appointmentId
      ).reactive = true;
      showNotification(
        'success',
        `The appointment has been reactivated`,
        this.toastr
      );
      this.modalRef.hide();
    });
  }

  onAddProblem(event, item): void {
    event.stopPropagation();

    if (item.hasProblem) {
      this.handleCloseProblem(item);
    } else {
      this.handleAddProblem(item);
    }
  }

  handleAddProblem(item) {
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        item,
      },
    };

    this.modalRef = this.modalService.show(
      AddProplemModalComponent,
      initialState
    );

    this.modalRef.content.event.subscribe((proplemDescription) => {
      this.onAddProplemSubmit(item, item.appointmentId, proplemDescription);
    });
  }

  onAddProplemSubmit(appointment, appointmentId, proplemDescription) {
    this._AllAppoint
      .addProblem(appointmentId, 'false', '')
      .subscribe((response) => {
        this.liveAppointmentsArray.find(
          (app) => app.appointmentId === appointmentId
        ).hasProblem = true;

        showNotification('success', `The problem has been added`, this.toastr);
        this.modalRef.hide();
      });
  }

  handleCloseProblem(item) {
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered modal-danger',
      initialState: {
        itemId: item.appointmentId,
      },
    };

    this.modalRef = this.modalService.show(
      CloseProblemModalComponent,
      initialState
    );

    this.modalRef.content.event.subscribe((appointmentId) => {
      this.onCloseProblemSubmit(item, appointmentId);
    });
  }

  onCloseProblemSubmit(appointment, appointmentId) {
    this._AllAppoint
      .addProblem(appointmentId, 'true', '')
      .subscribe((response) => {
        this.liveAppointmentsArray.find(
          (app) => app.appointmentId === appointmentId
        ).hasProblem = false;

        showNotification('success', `The problem has been closed`, this.toastr);
        this.modalRef.hide();
      });
  }
}
